import React, { useState } from "react";
import CustomModal from "../../components/CustomComponents/modal/customModal";

export default function DiscountRuleModal({
  showModal,
  setShowModal,
  onSubmit,
  selectedRule,
  setSelectedRule,
}) {
  const rules = [
    {
      name: "Category",
      description: "Apply to specific categories (e.g., Holiday items)",
    },
    {
      name: "Customer group",
      description: "Apply to a customer group (e.g., Regulars)",

    },
  ];

  const handleRuleSelection = (ruleName) => {
    setSelectedRule(ruleName);
  };

  const handleSubmit = () => {
    if (typeof onSubmit === "function") {
      onSubmit(selectedRule);
    }
    setShowModal(false);
  };

  return (
    <div>
      <CustomModal
        isOpen={showModal}
        title={"Apply discount to"}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        showButton={true}
        submitButtonText="Done"
      >
        <div>
          {rules.map((rule, index) => (
            <div
              key={index}
              className="border rounded p-3 mb-3"
              style={{ cursor: "pointer" }}
              onClick={() => handleRuleSelection(rule.name)}
            >
              <div className="d-flex align-items-center">
                <div className="form-check me-3">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="discountRule"
                    checked={selectedRule === rule.name}
                    onChange={() => handleRuleSelection(rule.name)}
                  />
                </div>
                <div>
                  <h6 className="mb-1">{rule.name}</h6>
                  <p className="text-muted mb-0">{rule.description}</p>
                  {rule.note && (
                    <small className="text-muted d-block mt-1">{rule.note}</small>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CustomModal>
    </div>
  );
}